module.exports = __webpack_public_path__ + "static/media/Design-thinking-process.a983a026.jpeg";